import { ListChart, ListChartProps } from '../../../../renderers/list-chart/list-chart.component';
import { VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION } from './vending-transaction-volume-by-state-list-chart.definition';
import { VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA } from './vending-transaction-volume-by-state-list-chart.mock';

export const VendingTransactionVolumeByStateListChart = (props: ListChartProps) => <ListChart {...props} />;

VendingTransactionVolumeByStateListChart.definition = VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION;
VendingTransactionVolumeByStateListChart.mockData = VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA;
